import { Link } from 'react-router-dom'
import LegalText from '../LegalText'
import Seo from '../Seo'
import MarketingNav from '../MarketingNav'
import MarketingFooter from '../MarketingFooter'
import PageHero from '../ds/PageHero'
import Section from '../ds/Section'
import Card from '../ds/Card'

// The chrome around a legal document. The four documents each have their OWN
// page file so that the route-level code split gives each one its own chunk.
//
// ⚠️ WHY NOT ONE PAGE WITH A :slug. It was exactly that, and a single component
// statically importing all four documents meant a visitor reading the Cookie
// Notice downloaded the Terms of Business, the Privacy Policy and the Worker
// Privacy Policy as well: ~105 KB of raw prose in one chunk, which was the whole
// of the first-load budget overage. Four pages, four chunks, one document each.
//
// ⛔ The document bodies are the LEGAL TEXT and are not touched here. This is
// chrome around them, and LegalText renders the document’s own "# Title" as an
// h2 because the page’s one h1 is below.

export default function LegalLayout({ slug, title, version, date, source }) {
  return (
    <div className="bg-canvas">
      <Seo
        title={title}
        description={`The TempDash ${title}, version ${version}, effective ${date}.`}
        path={`/legal/${slug}`}
      />
      <MarketingNav />

      <main id="main" tabIndex={-1} className="outline-none">

      <PageHero width="text" eyebrow="Legal" title={title} lead={`Version ${version} · Effective ${date}`}>
        <Link to="/legal" className="text-[16px] text-link underline underline-offset-4">
          All policies
        </Link>
      </PageHero>

      <Section ground="canvas" width="text">
        <Card pad="lg">
          <LegalText source={source} />
        </Card>
        <p className="mt-10 text-center text-[13px] font-semibold uppercase tracking-[0.12em] text-ink-muted">
          Version {version} · Effective {date}
        </p>
      </Section>

      </main>

      <MarketingFooter />
    </div>
  )
}
